import { gql } from '@apollo/client';

const BIDDING_VISIT_CORE_FIELDS = gql`
  fragment BiddingVisitCoreFields on BiddingVisit {
    id
    startAt
    checkInAt
    endAt
    audioStartAt
    audioEndAt
  }
`;

export const BIDDING_VISIT_FIELDS = gql`
  ${BIDDING_VISIT_CORE_FIELDS}
  fragment BiddingVisitFields on BiddingVisit {
    ...BiddingVisitCoreFields
    buyerUser {
      fullName
      paddleNumber
      buyer { name, status, cityState }
    }
  }
`;

export const BIDDING_VISITS = gql`
  ${BIDDING_VISIT_FIELDS}
  query BiddingVisits {
    biddingVisits {
      ...BiddingVisitFields
    }
  }
`;

export const SALE_BUYERS = gql`
  ${BIDDING_VISIT_FIELDS}
  query SaleBuyers(
    $id: ID!
    $scope: String!
  ) {
    sales {
      id
      name
    }
    sale(id: $id) {
      name
      activeBidders {
        ...BiddingVisitFields
      }
      buyerUsers(scope: $scope) {
        id
        fullName
        paddleNumber
        createdAt
        buyer {
          name
          companyName
          cityState
          status
        }
      }
      saleBuyerUsers {
        buyerUser { id }
        createdAt
      }
    }
  }
`;

export const SALE_LOT_BUYERS = gql`
  ${BIDDING_VISIT_FIELDS}
  query SaleLotBuyers($id: ID!) {
    sale(id: $id) {
      name
      lotBuyers {
        id
        startAt
        saleAsset {
          lotNumber
          asset { name }
        }
        visits {
          ...BiddingVisitFields
        }
        assetViews {
          buyerUser {
            fullName
            paddleNumber
            buyer { name, status, cityState }
          }
        }
        watching {
          buyerUser {
            fullName
            paddleNumber
            buyer { name, status, cityState }
          }
        }
      }
    }
  }
`;
